import { useMicrositeStaticUrl, getMetaTagContentByName } from 'utils/DOM';
import { isEmpty } from 'utils/string';

export const getVehicleImgUrl = ({ make, year, model }, countryCode) => {
  const endpoint = `${getMetaTagContentByName('xtime:consumerEndpoint')}`;
  const isSCIProd = useMicrositeStaticUrl();
  const originDefault = isSCIProd ? `//${endpoint}` : window.location.origin;
  const xmmOrigin = getMetaTagContentByName('xtime:xmmOrigin');
  const origin = !isEmpty(xmmOrigin) ? xmmOrigin : originDefault;
  return (
    `${origin}/oe/getVehicleImage?` +
    [
      `make=${encodeURIComponent(make)}`,
      `year=${encodeURIComponent(year)}`,
      `model=${encodeURIComponent(model)}`,
      `countryCode=${encodeURIComponent(countryCode)}`
    ].join('&')
  );
};

export const getBrandLogoUrl = (make, variant, locale) => {
  const xmmOrigin = getMetaTagContentByName('xtime:xmmOrigin');
  if (!isEmpty(xmmOrigin)) {
    return `${xmmOrigin}/oe/xmm/getBrandLogo?make=${make}&variant=${variant}&locale=${locale}&key=DEFAULT_LOGO`;
  }
  return `/xws/xmm/getBrandLogo?make=${make}&variant=${variant}&locale=${locale}&key=DEFAULT_LOGO`;
};



// WEBPACK FOOTER //
// ./src/utils/media.js